import { useFormik } from "formik"
import { useAppContext } from "providers/AppProvider/AppProvider"
import { useSettings } from "providers/SettingsProvider/SettingsProvider"
import { useUI } from "providers/UIProvider"
import { UI_INITIAL_STATE } from "providers/UIProvider/UIProviderConstants"
import { useEffect, useMemo } from "react"
import { useParams, useLocation } from "react-router-dom"
import { BOOKING_FEE_TABS, TType } from "types/shared"
import { generateFeeHistoryFromBookingFee } from "utils/feeHistoryUtils"
import * as Yup from "yup"

const BOOKING_FEE_INITIAL_VALUES = {
  amount: "",
  placeholderAmount: "",
}

const BOOKING_FEE_SCHEMA = (T: TType) => Yup.object({
  amount: Yup.lazy(value=>{
    if(value === "") {
      return Yup.string()
    }

    return  Yup
    .number()
    .required(T("booking_settings.form.validations.commission_amount_required"))
  })
})

const useBookingFee = () => {
  const params = useParams()
  const { pathname } = useLocation()

  const { T, modals, toggleModal } = useUI()
  const { commission, commissionTabType, handleChangeCommissionTab, handleChangeLaundryCommissionSubmit } = useSettings()
  const { branches, selectedBranches, updateSelectedBranches } = useAppContext()

  const laundryId = Number(params?.laundryId) || Number(modals.reservationCommissionModal.id) || null

  const LAUNDRY_URL_REGEX = /laundries\/[0-9]/

  const handleTabChange = (val: BOOKING_FEE_TABS) => {
    handleChangeCommissionTab(val)
  }
  const onSubmit = (val: any) => {
    if(pathname === "/settings/booking_fee") {
      toggleModal("feeHistoryModal", true, {
        data: generateFeeHistoryFromBookingFee({ 
          T, 
          inputData: branches.data, 
          selectedBranches,
          commission: { 
            commission: val.amount, 
            commissionType: commissionTabType === BOOKING_FEE_TABS.PERCENT ? 1 : 2
          } 
        }),
        handleDeny: () => toggleModal("feeHistoryModal", false, UI_INITIAL_STATE.modals.feeHistoryModal.data),
        handleSubmit: () => {
          handleChangeLaundryCommissionSubmit(selectedBranches, Number(val.amount))
          resetForm() 
          updateSelectedBranches([])
        }
      })
    } else if(laundryId !== null) {
      handleChangeLaundryCommissionSubmit([laundryId], val.amount)
    }
  }
  
  const { values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, resetForm } = useFormik({
    initialValues: BOOKING_FEE_INITIAL_VALUES,
    validationSchema: () => BOOKING_FEE_SCHEMA(T),
    onSubmit
  })
  
  // useEffect(()=>{
  //   if( commission !== undefined ) {
  //     setFieldValue("amount", "")
  //   } 
  // },[commissionTabType])
  useEffect(()=>{
    if(commission !== undefined && pathname.match(LAUNDRY_URL_REGEX)) {
      setFieldValue("placeholderAmount", `Current Commission is ${commission?.commission || ""} ${commission?.commissionType === 1 ? "%" : "ლ"}`)
    } 
  },[commission, commissionTabType])
  useEffect(()=>{
    if(commission !== undefined && pathname === "/settings/booking_fee" && selectedBranches.length === 1) {
      setFieldValue("placeholderAmount", `Current Commission is ${commission?.commission || ""} ${commission?.commissionType === 1 ? "%" : "ლ"}`)
    } else if (commission !== undefined && pathname === "/settings/booking_fee" && selectedBranches.length === 0) {
      setFieldValue("placeholderAmount", "Choose Laundry")
    } else if(commission !== undefined && pathname === "/settings/booking_fee" && selectedBranches.length > 1) {
      setFieldValue("placeholderAmount", "Choose One Laundry")
    }
  },[commission, commissionTabType, selectedBranches.length])







  
  
  
  

  return useMemo(
    () => ({
      form: {
        values, touched, errors, handleChange, handleBlur, handleSubmit, setFieldValue, resetForm
      },
      handleTabChange
    }),
    [values, errors, touched],
  )
}

export default useBookingFee